<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <div class="shadow-none">
            <div
              class="d-flex justify-space-between flex-wrap align-center"
            >
              <v-card-title>
                Third-Party Channels ({{ channels.length }})
              </v-card-title>
              <div class="pa-2">
                <v-btn
                  outlined
                  class="ma-2"
                  color="primary"
                  @click="goToEditMeta()"
                >
                  <i class="mdi mdi-pencil p-r-5" />
                  Edit Metadata
                </v-btn>
                <v-btn
                  :disabled="loading"
                  color="primary"
                  @click="goToNew()"
                >
                  <i class="mdi mdi-plus p-r-5" />
                  add
                </v-btn>
              </div>
            </div>
          </div>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Company
                    </th>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Genre
                    </th>
                    <th class="text-left">
                      Package
                    </th>
                    <th class="text-left">
                      HLS
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="channel in channels"
                    :key="channel.id"
                    class="text--pointer"
                  >
                    <td
                      class="text-no-wrap"
                      @click="goToDetails(channel)"
                    >
                      {{ channel.company }}
                    </td>
                    <td
                      class="font-weight-bold text-no-wrap"
                      @click="goToDetails(channel)"
                    >
                      {{ channel.name }}
                    </td>
                    <td @click="goToDetails(channel)">
                      <v-chip
                        v-for="(genre, genreIndex) of channel.genres.slice(0, 1)"
                        :key="genre.id"
                        outlined
                        small
                        :class="{
                          'm-r-5': channel.genres.length > 0 && genreIndex < channel.genres.length-1,
                        }"
                      >
                        {{ genre.name }}
                      </v-chip>
                      <v-chip
                        v-if="channel.genres.length > 1"
                        outlined
                        small
                        class="text-uppercase blocked-text m-l-5"
                      >
                        +{{ channel.genres.length - 1 }}
                      </v-chip>
                    </td>
                    <td
                      class="text-no-wrap"
                      @click="goToDetails(channel)"
                    >
                      {{ channel.targetPackage }}
                    </td>
                    <td>
                      <v-btn
                        class="mx-2 shadow-none blue darken-1"
                        fab
                        dark
                        x-small
                        @click.prevent="openPlayer(channel.url, channel.name)"
                      >
                        <v-icon>mdi-play</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-menu
                        left
                        bottom
                      >
                        <template v-slot:activator="{on}">
                          <v-btn
                            icon
                            v-on="on"
                          >
                            <v-icon
                              class=""
                            >
                              mdi-dots-horizontal
                            </v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item @click.stop="openRemoveDialog(channel)">
                            <v-icon
                              class="text-body-1 mr-2"
                            >
                              mdi-trash-can
                            </v-icon>
                            <v-list-item-title>
                              Delete
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
    <!-- Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete channel?
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              Are you sure you want to delete the channel "{{ deleted.name }}"?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteChannel()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-l-20 p-r-20">
                {{ playerTitle }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import { processThirdPartyChannel } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'Distribution Packages',
    },
    data () {
      return {
        channels: [],
        deleted: {},
        removeDialog: false,
        playerDialog: false,
        playerTitle: '',
        frameSrc: '',
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      defaultIcon () {
        return '/images/no_logo.jpeg'
      },
    },
    watch: {
      'playerDialog' (to, from) {
        if (to === false) {
          this.closePlayer()
        }
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const args = {
          $expand: '*',
        }
        const channelReq = this.$store.dispatch('thirdPartyChannels', args)

        return Promise.all([channelReq])
          .then((res) => {
            const channels = res[0]
            this.channels = channels.map((ch) => processThirdPartyChannel(ch))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'ChannelsPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      goToDetails (channel) {
        this.$router.push({
          name: 'ThirdPartyChannel',
          params: {
            channel_id: channel.id,
          },
        })
      },
      goToNew () {
        this.$router.push({
          name: 'NewThirdPartyChannel',
        })
      },
      openRemoveDialog (ch) {
        this.deleted = ch
        this.removeDialog = true
      },
      deleteChannel () {
        if (!this.deleted.id) return

        this.$store.commit('setPageLoader')
        this.$store.dispatch('deleteThirdPartyChannel', this.deleted.id)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The channel has been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.loadData()
            this.deleted = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      openPlayer (url, title) {
        this.setFrameSrc(url)
        this.playerDialog = true
        this.playerTitle = title
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.playerTitle = ''
        this.setFrameSrc('')
      },
      goToEditMeta () {
        this.$router.push({
          name: 'ThirdPartyChannelBatchEdit',
        })
      },
    },
  }
</script>

<style>

</style>
